module.exports = __webpack_public_path__ + "img/symbol_5.fe57758d.png";